import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import siteConfig from "./siteConfig";
import tr from "./locales/tr/translation.json";
import en from "./locales/en/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
  },
  lng: siteConfig.locale,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = siteConfig.locale;
}

export default i18n;
